import React from 'react'
import SystemSettings from '@/components/SystemSettings'

/**
 * Settings page - Shows system settings and account management
 * Route: /dashboard/settings
 */
export const SettingsPage: React.FC = () => {
  return <SystemSettings />
}
